// extracted by mini-css-extract-plugin
export default {"select-tests":"selectTests_select-tests__Dcp7I","continue-btn":"selectTests_continue-btn__B9IeW"};